import { browserName, browserVersion, isMacOs, isIOS, isAndroid, isWindows, isMobile, osName } from "react-device-detect";
import {
  MINI_CHROME_WIN_VERSION,
  MINI_CHROME_ANDROID_VERSION,
  MINI_CHROME_IOS_VERSION,
  MINI_CHROME_MACOS_VERSION,
  MINI_CHROME_OTHER_VERSION,
  MINI_IE_VERSION,
  MINI_SAFARI_VERSION,
  MINI_EDGE_VERSION
} from '../constants/supported-browser-versions';

export const useBrowserDetection = () => {
  let isAllowed = false;
  switch (browserName){
    case 'Chrome':
      if(isWindows){
        isAllowed = (parseInt(browserVersion, 10)) >= MINI_CHROME_WIN_VERSION;
      }else if(isMacOs){
        isAllowed = (parseInt(browserVersion, 10)) >= MINI_CHROME_MACOS_VERSION;
      }else if(isAndroid && isMobile){
        isAllowed = (parseInt(browserVersion, 10)) >= MINI_CHROME_ANDROID_VERSION;
      }else if(isIOS && isMobile){
        isAllowed = (parseInt(browserVersion, 10)) >= MINI_CHROME_IOS_VERSION;
      }else{
        isAllowed = (parseInt(browserVersion, 10)) >= MINI_CHROME_OTHER_VERSION;
      }
      break;
    case 'IE':
      isAllowed = (parseInt(browserVersion, 10)) > MINI_IE_VERSION;
      break;
    case 'Safari':
      isAllowed = (parseInt(browserVersion, 10)) >= MINI_SAFARI_VERSION;
      break;
    case 'Mobile Safari':
      isAllowed = (parseInt(browserVersion, 10)) >= MINI_SAFARI_VERSION;
      break;
    case 'Edge':
      isAllowed = (parseInt(browserVersion, 10)) >= MINI_EDGE_VERSION;
      break;
      case 'Firefox':
      case 'Samsung Browser':
        isAllowed = true;
        break;
    default:
      break;
  }
  return {isAllowed, browserName, browserVersion, isMacOs, isIOS, isAndroid, isWindows, isMobile, osName};
}
